import * as React from "react";

interface MyAvailabilityForwardProps extends React.SVGProps<SVGSVGElement> {
  stroke?: string;
}

const MyAvailabilityForward: React.FC<MyAvailabilityForwardProps> = ({
  stroke = "#292A34", // default color
  ...props
}) => (
  <svg
    width={11}
    height={17}
    viewBox="0 0 11 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.54883 15.5062L8.74801 8.30704L1.54883 1.10785"
      stroke={stroke}
      strokeWidth={2.05691}
    />
  </svg>
);

export default MyAvailabilityForward;
